/**
 * ProjectEditDialog — 投标信息 Tab
 */
import React from 'react';

interface BidInfoTabProps {
  bidTotalPrice: string;
  setBidTotalPrice: (v: string) => void;
  bidDuration: string;
  setBidDuration: (v: string) => void;
  projectManager: string;
  setProjectManager: (v: string) => void;
  contactPerson: string;
  setContactPerson: (v: string) => void;
  contactPhone: string;
  setContactPhone: (v: string) => void;
  contactEmail: string;
  setContactEmail: (v: string) => void;
  bidAgent: string;
  setBidAgent: (v: string) => void;
  otherInfo: string;
  setOtherInfo: (v: string) => void;
}

export default function BidInfoTab({
  bidTotalPrice, setBidTotalPrice,
  bidDuration, setBidDuration,
  projectManager, setProjectManager,
  contactPerson, setContactPerson,
  contactPhone, setContactPhone,
  contactEmail, setContactEmail,
  bidAgent, setBidAgent,
  otherInfo, setOtherInfo,
}: BidInfoTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">投标总价</label>
          <div className="flex items-center gap-2">
            <input type="text" value={bidTotalPrice} onChange={(e) => setBidTotalPrice(e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="请输入投标总价" />
            <span className="text-sm text-gray-500 whitespace-nowrap">万元</span>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">工期</label>
          <div className="flex items-center gap-2">
            <input type="text" value={bidDuration} onChange={(e) => setBidDuration(e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="请输入工期" />
            <span className="text-sm text-gray-500 whitespace-nowrap">天</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">项目经理</label>
          <input type="text" value={projectManager} onChange={(e) => setProjectManager(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="项目经理姓名" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">项目联系人</label>
          <input type="text" value={contactPerson} onChange={(e) => setContactPerson(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="联系人姓名" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">联系电话</label>
          <input type="text" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="联系人电话" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">电子邮件</label>
          <input type="text" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="联系人邮箱" />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          投标代理人 <span className="text-gray-400 font-normal text-xs ml-1">（法人授权）</span>
        </label>
        <input type="text" value={bidAgent} onChange={(e) => setBidAgent(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="代理人姓名" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          其他信息 <span className="text-gray-400 font-normal text-xs ml-1">（提词说明，将作为提示词的一部分传递给 LLM）</span>
        </label>
        <textarea value={otherInfo} onChange={(e) => setOtherInfo(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          rows={4} placeholder="输入其他需要包含在提词中的说明信息..." />
      </div>
    </div>
  );
}
